import React from 'react';

export default function BookingOutcomeNotice({ state }) {
    if (!state?.bookingPending && !state?.bookingRejected) return null;
    const rejected = state.bookingRejected || state.confirmationStatus === 'rejected';
    return (
        <div className={`alert ${rejected ? 'alert-danger' : 'alert-warning'} booking-insurance-notice`} role="alert">
            <strong>{rejected ? 'The courier rejected your booking.' : 'Your booking is still being finalized.'}</strong>
            <span>{state.bookingMessage || (rejected
                ? 'The shipment was not confirmed. Contact support to review the booking.'
                : 'We received your payment but could not confirm the final booking status yet.')}</span>
            <span>Payment was received. Do not pay again. {rejected
                ? 'Contact support to review the shipment details and resolve the payment before another booking attempt.'
                : 'Do not submit another booking while confirmation is being checked.'}</span>
            {state.insuranceSelected && <span>{rejected
                ? 'Paid insurance has not been confirmed. Contact support to check its status.'
                : 'Paid insurance status: pending confirmation. We’ll show its confirmed status here when the booking update arrives.'}</span>}
        </div>
    );
}